import ReactGA from 'react-ga';
import config from 'config';
import { basenameUrl } from './utils';

const trackPageView = (location) => {
  const basenameLocation = basenameUrl(location.pathname);
  ReactGA.set({
    page: basenameLocation,
  });
  ReactGA.pageview(basenameLocation);
};

const initGa = (history) => {
  ReactGA.initialize(config.googleAnalyticsId, {
    testMode: process.env.NODE_ENV === 'test',
  });
  trackPageView(history.location);
  history.listen(trackPageView);
};

export { initGa as default, trackPageView };
